import Vue from 'vue'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'
import castArray from 'lodash/castArray'

export default class {
  constructor (initial) {
    Object.defineProperties(this, {
      _default: {
        configurable: true,
        enumerable: false,
        value: cloneDeep(initial),
        writable: false
      },
      _current: {
        configurable: true,
        enumerable: false,
        value: cloneDeep(initial),
        writable: false
      },
      _messages: {
        configurable: true,
        enumerable: false,
        value: [],
        writable: false
      }
    })

    Vue.util.defineReactive(this, '_default')
    Vue.util.defineReactive(this, '_current')
    Vue.util.defineReactive(this, '_messages')
  }

  /**
   * Determines if the field has been modified.
   */
  get modified () {
    return !isEqual(this._default, this._current)
  }

  /**
   * Determins if the field is valid.
   */
  get valid () {
    return this
      .messages
      .length === 0
  }

  /**
   * Determins if the field is invalid.
   */
  get invalid () {
    return !this.valid
  }

  /**
   * Returns the first validation message.
   */
  get message () {
    return this._messages.find(message => typeof message !== 'undefined')
  }

  /**
   * Returns the an array of validation messages.
   */
  get messages () {
    return this._messages.filter(message => typeof message !== 'undefined')
  }

  /**
   * Sets the validation messages.
   */
  set messages (value) {
    Vue.set(this, '_messages', castArray(value))
  }

  /**
   * Sets the default field value.
   */
  get default () {
    return this.accessor(this._default)
  }

  /**
   * Sets the default field value.
   */
  set default (value) {
    Vue.set(this, '_default', this.mutator(value))
    this.current = value
  }

  /**
   * Gets the current field value.
   */
  get current () {
    return this.accessor(this._current)
  }

  /**
   * Sets the current field value.
   */
  set current (value) {
    this.messages = []
    Vue.set(this, '_current', this.mutator(value))
  }

  /**
   * Access the passed field value.
   */
  accessor (value) {
    return value
  }

  /**
   * Mutate the passed field value.
   */
  mutator (value) {
    return value
  }

  /**
   * Resets the field value to the original value.
   */
  reset () {
    Vue.set(this, '_current', this._default)
  }

  /**
   * Returns a copy of the field value.
   */
  copy () {
    return cloneDeep(this.current)
  }

  /**
   * @see    {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON()_behavior}
   */
  toJSON () {
    return this.current
  }
}
